import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/projects")({
  component: () => <Outlet />,
});
